
// Application Global Configuration
//export const API_BASE_URL = 'http://localhost:3033/api';
export const API_BASE_URL = 'https://automationapi.lotuscapitallimited.com/api';
//export const API_BASE_URL = 'https://testautomationapi.lotuscapitallimited.com/api';

export const APP_ITEMS_ENDPOINT = `${API_BASE_URL}/app/get-appitems`;
export const GETAPPITEMS_BYID_ENDPOINT = `${API_BASE_URL}/app/get-appitem`;
export const GETCATEGORIES_ENDPOINT = `${API_BASE_URL}/app/get-categories`;
export const USER_PRIVILEGES_ENDPOINT = `${API_BASE_URL}/user/getUserPrivileges`;
export const ADDAPPITEMS_ENDPOINT = `${API_BASE_URL}/app/add-appitem`;
export const GETCOLORTAG_ENDPOINT = `${API_BASE_URL}/app/get-colortags`;
export const ADDCATEGORY_ENDPOINT = `${API_BASE_URL}/app/add-category`;
export const UPDATECOLORTAG_ENDPOINT = `${API_BASE_URL}/app/update-colortags`;
export const GETDEPT_ENDPOINT = `${API_BASE_URL}/user/getdept`;
export const GETDEPTBYID_ENDPOINT = `${API_BASE_URL}/user/getdeptbyID`;
export const ADDDEPT_ENDPOINT = `${API_BASE_URL}/user/add-dept`;
export const UPDATEDEPT_ENDPOINT = `${API_BASE_URL}/user/update-dept`;
export const DELETEDEPT_ENDPOINT = `${API_BASE_URL}/user/delete-dept`;
export const GETUSERROLE_ENDPOINT = `${API_BASE_URL}/user/getrole`;
export const CREATEUSER_ENDPOINT = `${API_BASE_URL}/user/createUser`;
export const GETUSERBYEMAIL_ENDPOINT = `${API_BASE_URL}/user/getuserbyemail`;
export const ADDUSERPRIVILLAGES_ENDPOINT = `${API_BASE_URL}/user/add-userprivileges`;
export const UPDATEAPPITEM_ENDPOINT = `${API_BASE_URL}/app/update-appitem`;
export const GETCATEGORYBYID_ENDPOINT = `${API_BASE_URL}/app/get-category`;
export const UPDATECATEGORY_ENDPOINT = `${API_BASE_URL}/app/update-category`;
export const RESETPASSWORD_ENDPOINT = `${API_BASE_URL}/user/resetpassword`;
export const DELETEUSER_ENDPOINT = `${API_BASE_URL}/user/deleteuserbyemail`;
export const DELETEUSERPRIVILLAGE_ENDPOINT = `${API_BASE_URL}/user/deletePrivilage`;
export const UPDATEUSERINFO_ENDPOINT = `${API_BASE_URL}/user/updateUser`;
export const VALIDATEUSER_ENDPOINT = `${API_BASE_URL}/user/validate`;
export const GETUSERS_ENDPOINT = `${API_BASE_URL}/user/getusers`;
export const GETUSERSBYID_ENDPOINT = `${API_BASE_URL}/user/getuserbyID`;
export const DELETECATEGORY_ENDPOINT = `${API_BASE_URL}/app/delete-category`;
export const DELETEAPPITEM_ENDPOINT = `${API_BASE_URL}/app/delete-appitem`;
export const ADDACTIVITYLOG_ENDPOINT = `${API_BASE_URL}/app/addactivitylog`; 
export const GETACTIVITYLOG_ENDPOINT = `${API_BASE_URL}/app/getactivitylog`;
export const GETAUDITLOGWITHRANGE_ENDPOINT = `${API_BASE_URL}/app/getauditlogwithrange`;
export const RESETUSERPASSWORD_ENDPOINT = `${API_BASE_URL}/user/resetuserpassword`;


// 1:  Tracking system Module


export const UPLOADANDMERGEPDF_ENDPOINT = `${API_BASE_URL}/app/uploadAndMergePDF`;
export const UPDATEAPPROVALSTATUS_ENDPOINT = `${API_BASE_URL}/app/updateApprovalStatus`;
export const DELETEAPPROVER_ENDPOINT = `${API_BASE_URL}/app/deleteUser`;
export const GETTRANSACTIONCOUNT_ENDPOINT = `${API_BASE_URL}/app/gettransactioncounts`;
export const ADDAPPROVER_ENDPOINT = `${API_BASE_URL}/app/addUsers`;
export const GETAPPROVER_ENDPOINT = `${API_BASE_URL}/app/getUsers`;
export const GETPOSTEDTRANSACTIONS_ENDPOINT = `${API_BASE_URL}/app/getpostedtransactions`;
export const GETCOMPLETEDTRANSACTIONS_ENDPOINT = `${API_BASE_URL}/app/getcompletedtransactions`;
export const GETUSERSETTINGS_ENDPOINT = `${API_BASE_URL}/app/getUserSettings`;
export const UPDATEUSERSETTINGS_ENDPOINT = `${API_BASE_URL}/app/updateUserSettings`;
export const GETINVESTMENTPRODUCT_ENDPOINT = `${API_BASE_URL}/app/getInvestmentProducts`;
export const COMPLETETRANSACTION_ENDPOINT = `${API_BASE_URL}/app/completeApprovalStatus`;
export const FAILTRANSACTION_ENDPOINT = `${API_BASE_URL}/app/uploadAndMergePDF`;
export const GETALLTRANSACTIONS_ENDPOINT = `${API_BASE_URL}/app/getAlltransactions`;
export const BULKAPPROVAL_ENDPOINT = `${API_BASE_URL}/app/bulkApproval`;
export const GETTRANSACTIONBYDATE_ENDPOINT = `${API_BASE_URL}/app/getcompletedtransactionsByDate`;
export const GETATTACHMENT_ENDPOINT = `${API_BASE_URL}/app/getattachmentbyrequestno`;



//End

//Modules Configurations ( Add all new modules config parameters here)

